import React, { useEffect, useState } from 'react';
import { FiArrowLeft, FiCopy, FiCheck } from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router';
import { getDecryptedData } from '../config/crypto';
import axios from 'axios';
import { IMAGE_URL, PROMPT_VIDEO_URL, REACT_APP_API_PORT } from '../Api';
import Header from "../components/headerfooter/Header";
import Loader from '../components/Loader';
import { motion, AnimatePresence } from "framer-motion";
import { BiBookmark, BiBookmarkHeart } from "react-icons/bi";
import { toast } from 'react-toastify';
import VideoPreview from '../components/VideoPreview';
import MobileFooter from "../components/MobileFooter";
import { FaBookmark, FaCrown } from "react-icons/fa";
import { MdContentCopy } from "react-icons/md";
// import WhatsAppChatButton from '../components/WhatsAppChatButton';

const PromptDetailPage = () => {
    const [copiedPrompt, setCopiedPrompt] = useState(null);
    const [data, setData] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();

    const [showFullImagePrompt, setShowFullImagePrompt] = useState(false);
    const [showFullVideoPrompt, setShowFullVideoPrompt] = useState(false);
    const [showFullDescription, setShowFullDescription] = useState(false);
    const [plainTextLength, setPlainTextLength] = useState(0);
    const [copiedId, setCopiedId] = useState(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'auto', // This enables smooth scrolling
        });
    }, []); // Empty dependency array ensures it runs only once when the component mounts


    const getData = async () => {
        try {
            setisLoading(true);
            const user = getDecryptedData("user");
            let userId = user ? user._id : "";
            const res = await axios.get(
                `${REACT_APP_API_PORT}user/homepage/prompt/show/${id}?userId=${userId}`
            );
            setisLoading(false);
            if (res.data.status) {
                setData(res.data.data);
            }
        } catch (err) {
            setisLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const handleCopy = (text, key) => {
        navigator.clipboard.writeText(text);
        setCopiedPrompt(key);
        setTimeout(() => setCopiedPrompt(null), 1500);
    };

    const handleSaveTool = async () => {
        const user = getDecryptedData("user");
        if (!user) {
            navigate(`/login`);
        }
        if (user) {
            try {
                setisLoading(true);
                const token = getDecryptedData('token');
                const res = await axios.post(`${REACT_APP_API_PORT}user/frontend/save-prompt`, {
                    prompt_id: id,
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token
                    }
                });
                setisLoading(false);
                if (res.data.status) {
                    getData();
                }
            } catch (err) {
                setisLoading(false);
                if (err.response?.data?.status === false) {
                    toast.error(err.response.data.message);
                }
            }
        }
    };

    const truncateText = (text, limit) => {
        return text.length > limit ? text.slice(0, limit) + '...' : text;
    };

    const truncateHtml = (html, maxLength) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        const text = div.textContent || div.innerText || "";
        return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    };

    useEffect(() => {
        if (data?.short_description) {
            const div = document.createElement("div");
            div.innerHTML = data.short_description;
            const text = div.textContent || div.innerText || "";
            setPlainTextLength(text.length);
        }
    }, [data?.short_description]);

    return (
        <>
            {/* <WhatsAppChatButton /> */}
            <Loader isLoading={isLoading} />
            <Header />
            <div className="bg-background-back1 text-white min-h-screen py-8 px-4 mb-10 md:mb-0 pt-20">
                <div className="max-w-6xl mx-auto blurBox bg-gray-900 p-6 rounded-lg shadow-lg">
                    <div className='flex justify-between items-start'>
                        <button
                            onClick={() => window.history.back()}
                            className="flex items-center text-sm text-white hover:text-white mb-6 mt1-2 custom-back py-2 px-3 font-bold rounded hover:bg-primary"
                        >
                            <FiArrowLeft className="mr-2" /> Back
                        </button>

                        <div className='flex gap-2 lg1:hidden'>
                    

                            <button
                                type="button"
                                onClick={() => {
                                    const prompts = [];
                                    if (data.image_prompt) prompts.push(`Image Prompt: ${data.image_prompt}`);
                                    if (data.video_prompt) prompts.push(`\nVideo Prompt: ${data.video_prompt}`);

                                    if (prompts.length === 0) return;

                                    const textToCopy = prompts.join("\n");
                                    navigator.clipboard.writeText(textToCopy).then(() => {
                                        setCopiedId(data._id);
                                        setTimeout(() => setCopiedId(null), 2000);
                                    });
                                }}
                                className="group border flex border-customBlue px-3 py-2 rounded text-white hover:bg-background-primary transition text-[14px] custom-back font-bold uppercase1 hover:text-white"
                            >
                                {copiedId === data._id ? (
                                    "Copied!"
                                ) : (
                                    <>
                                        Copy <span className="md:block hidden">All Prompts</span>
                                    </>
                                )}
                            </button>


                            <button
                                type="button"
                                onClick={handleSaveTool}
                                className="group border custom-back flex border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase hover:text-white"
                            >
                                <AnimatePresence mode="wait">
                                    {data?.is_saved ? (
                                        <motion.div
                                            key="saved"
                                            initial={{ opacity: 0, scale: 0.5 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0.5 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <div className="flex gap-2 items-center">
                                                <FaBookmark className="w-5 h-5 text-white group-hover:text-white" />
                                                {data?.total_saved > 0 && data.total_saved}
                                            </div>
                                        </motion.div>
                                    ) : (
                                        <motion.div
                                            key="unsaved"
                                            initial={{ opacity: 0, scale: 0.5 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0.5 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <div className="flex gap-2 items-center">
                                                <BiBookmark className="w-5 h-5 text-white group-hover:text-white" />
                                                {data?.total_saved > 0 && data.total_saved}
                                            </div>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </button>
                        </div>
                    </div>



                    <div className="flex flex-col lg:flex-row gap-6 mb-8">
                        <div className="lg:w-1/2 w-full">
                            {
                                (data.prompt_type === "Image Prompt") && <>
                                    <img
                                    loading="lazy"
                                    decoding="async"
                                        src={data.image ? IMAGE_URL + data.image : "/just-launch-default.png"}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = '/just-launch-default.png';
                                        }}
                                        alt="Prompt Banner"
                                        className="w-full  lg:h1-auto max1-h-[800px] w-[600px] max-h-[600px] object1-cover rounded-lg shadow-md"
                                    />
                                </>
                            }

                            {
                                (data?.prompt_type === "Video Prompt") && <>
                                    {data?.video && (
                                        <video
                                            src={PROMPT_VIDEO_URL + data.video}
                                            autoPlay
                                            muted
                                            loop
                                            className="w-full  lg:h1-auto max1-h-[800px] w-[600px] max-h-[600px] mt-3 rounded-lg object-cover  cardimgh"

                                        />
                                    )}

                                </>
                            }
                     

                        </div>

                        <div className="lg:w-1/2 w-full space-y-6">
                            <div className='flex justify-between gap-6 mb-0 pb-0'>
                                <div className='flex items-center'>
                                    <h1 className="text-2xl font-bold text-gray-300 ">{data?.title}</h1>
                                </div>
                                <div className='flex gap-4 hidden lg1:flex'>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            const prompts = [];
                                            if (data.image_prompt) prompts.push(`Image Prompt: ${data.image_prompt}`);
                                            if (data.video_prompt) prompts.push(`\nVideo Prompt: ${data.video_prompt}`);

                                            if (prompts.length === 0) return;

                                            const textToCopy = prompts.join("\n");
                                            navigator.clipboard.writeText(textToCopy).then(() => {
                                                setCopiedId(data._id);
                                                setTimeout(() => setCopiedId(null), 2000);
                                            });
                                        }}
                                        className="hidden lg:block group border flex border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase hover:text-white"
                                    >
                                        {copiedId === data._id ? "Copied!" : "Copy Prompts"}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleSaveTool}
                                        className="group border custom-back flex border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase hover:text-white"
                                    >
                                        <AnimatePresence mode="wait">
                                            {data?.is_saved ? (
                                                <motion.div
                                                    key="saved"
                                                    initial={{ opacity: 0, scale: 0.5 }}
                                                    animate={{ opacity: 1, scale: 1 }}
                                                    exit={{ opacity: 0, scale: 0.5 }}
                                                    transition={{ duration: 0.3 }}
                                                >
                                                    <div className="flex gap-2 items-center">
                                                        <BiBookmarkHeart className="w-5 h-5 text-primary group-hover:text-white" />
                                                        {data?.total_saved > 0 && data.total_saved}
                                                    </div>
                                                </motion.div>
                                            ) : (
                                                <motion.div
                                                    key="unsaved"
                                                    initial={{ opacity: 0, scale: 0.5 }}
                                                    animate={{ opacity: 1, scale: 1 }}
                                                    exit={{ opacity: 0, scale: 0.5 }}
                                                    transition={{ duration: 0.3 }}
                                                >
                                                    <div className="flex gap-2 items-center">
                                                        <BiBookmark className="w-5 h-5 text-primary group-hover:text-white" />
                                                        {data?.total_saved > 0 && data.total_saved}
                                                    </div>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </button>
                                </div>
                            </div>

                       

                            <div className="text-gray-400">
                                {showFullDescription ? (
                                    <div dangerouslySetInnerHTML={{ __html: data?.short_description || "" }} />
                                ) : (
                                    <p>{truncateHtml(data?.short_description || "", 300)}</p>
                                )}

                                {plainTextLength > 300 && (
                                    <button
                                        onClick={() => setShowFullDescription(!showFullDescription)}
                                        className="ml-2 text-blue-400 hover:underline"
                                    >
                                        {showFullDescription ? "Read Less" : "Read More"}
                                    </button>
                                )}
                            </div>


                            <div className="flex flex-wrap gap-2">
                                {data && data?.tags?.length > 0 && data?.tags.map((tag, index) => (
                                     <span
                                                key={index}
                                                className="px-3 py-1 mt-1 text-sm rounded  custom-back text-gray-200 
                     border border1-gray-700 border-customBlue cursor-default 
                     transition-colors duration-200"
                                            >
                                                {tag}
                                            </span>
                                ))}
                            </div>

                            {(data?.image_prompt && data?.image_prompt !== "") && (
                                <div className="relative">
                                    <h2 className="text-xl font-semibold text-gray-200 mb-2">Image Prompt</h2>
                                    <div className='bg-[#171717] p-3 rounded mb-3'>
                                        <button
                                            onClick={() => handleCopy(data.image_prompt, 'image')}
                                            className="flex items-center gap-1 text-sm   ml-auto font-bold hover:text-white px-3 py-1 rounded transition-all mb-2"
                                        ><MdContentCopy />
                                            {/* {copiedPrompt === 'image' ? <FiCheck /> : <FiCopy />} */}
                                            {copiedPrompt === 'image' ? "Copied" : "Copy Prompt"}
                                        </button>
                                        <p className="text-gray-400">
                                            {showFullImagePrompt ? data.image_prompt : truncateText(data.image_prompt, 300)}
                                            {data.image_prompt.length > 300 && (
                                                <button
                                                    onClick={() => setShowFullImagePrompt(!showFullImagePrompt)}
                                                    className="ml-2 text-blue-400 hover:underline"
                                                >
                                                    {showFullImagePrompt ? "Read Less" : "Read More"}
                                                </button>
                                            )}
                                        </p>
                                    </div>

                                </div>
                            )}

                            {(data?.video_prompt && data?.video_prompt !== "") && (
                                <div className="relative">
                                    <h2 className="text-xl font-semibold text-gray-200 mb-2">Video Prompt</h2>
                                    <div className='bg-[#171717] p-3 rounded mb-3'>
                                        <button
                                            onClick={() => handleCopy(data.video_prompt, 'text')}
                                            className="flex items-center gap-1 text-sm   ml-auto font-bold hover:text-white px-3 py-1 rounded transition-all mb-2"
                                        >
                                            <MdContentCopy />
                                            {copiedPrompt === 'text' ? "Copied" : "Copy Prompt"}
                                        </button>
                                        <p className="text-gray-400 mb1-3 ">
                                            {showFullVideoPrompt ? data.video_prompt : truncateText(data.video_prompt, 300)}
                                            {data.video_prompt.length > 300 && (
                                                <button
                                                    onClick={() => setShowFullVideoPrompt(!showFullVideoPrompt)}
                                                    className="ml-2 text-blue-400 hover:underline"
                                                >
                                                    {showFullVideoPrompt ? "Read Less" : "Read More"}
                                                </button>
                                            )}
                                        </p>

                                    </div>

                                </div>
                            )}
                        </div>
                    </div>
                    <div className='grid max-w-lg'>
                        {
                            (data?.instagram_link && data?.instagram_link !== "") && <>
                                <div className='mb-3'>
                                    <h1 className='text-blu-500 font-bold mb-2'>Check out instagram refrence </h1>
                                    <VideoPreview url={data?.instagram_link} />
                                </div>
                            </>
                        }

                        {
                            (data?.youtube_link && data?.youtube_link !== "") && <>
                                <div className=''>
                                    <h1 className='text-blu-500 font-bold mb-2'>Check out youtube refrence </h1>
                                    <VideoPreview url={data?.youtube_link} />
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
            <MobileFooter />
        </>
    );
};

export default PromptDetailPage;